var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidePanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13687",
    "data-name": "Group 13687",
    transform: "translate(-1846 -3557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4574",
    "data-name": "Rectangle 4574",
    className: "cls-1",
    width: 50,
    height: 30,
    transform: "translate(1846 3557)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13686",
    "data-name": "Group 13686",
    transform: "translate(0.114 -0.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    className: "cls-2",
    d: "M6812.508,717.875a2.14,2.14,0,0,1-.913-.2l-21.27-9.983-21.268,9.983a2.151,2.151,0,1,1-1.827-3.894l23.1-10.841,23.1,10.841a2.151,2.151,0,0,1-.914,4.1Z",
    transform: "translate(-4919.383 2857.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    className: "cls-2",
    d: "M6812.508,717.875a2.14,2.14,0,0,1-.913-.2l-21.27-9.983-21.268,9.983a2.151,2.151,0,1,1-1.827-3.894l23.1-10.841,23.1,10.841a2.151,2.151,0,0,1-.914,4.1Z",
    transform: "translate(-4919.383 2867.441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidePanel);
export default __webpack_public_path__ + "static/media/SidePanel.938cb416009bda19ec30322265c37d89.svg";
export { ForwardRef as ReactComponent };